export enum VaultStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  AVAILABLE = 'AVAILABLE',
  READY = 'READY',
  APPROVED = 'APPROVED',
  PUBLISHED = 'PUBLISHED',
  REVOKED = 'REVOKED',
}
